import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "profile-outline-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.34835 7.34835C10.8128 5.88388 13.1872 5.88388 14.6516 7.34835C16.1161 8.81282 16.1161 11.1872 14.6516 12.6516C13.1872 14.1161 10.8128 14.1161 9.34835 12.6516C7.88388 11.1872 7.88388 8.81282 9.34835 7.34835ZM10.409 8.40901C11.2877 7.53033 12.7123 7.53033 13.591 8.40901C14.4697 9.28769 14.4697 10.7123 13.591 11.591C12.7123 12.4697 11.2877 12.4697 10.409 11.591C9.53033 10.7123 9.53033 9.28769 10.409 8.40901Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.8943 5.10571C22.7019 8.91332 22.7019 15.0867 18.8943 18.8943C15.0867 22.7019 8.9133 22.7019 5.10571 18.8943C1.2981 15.0867 1.2981 8.9133 5.10571 5.10571C8.91332 1.2981 15.0867 1.2981 18.8943 5.10571ZM17.8336 6.16637C14.6118 2.94454 9.3882 2.94454 6.16637 6.16637C3.13071 9.20201 2.9553 14.0148 5.64014 17.2558C5.7704 17.0026 5.91878 16.7646 6.08363 16.5448C6.76701 15.6336 7.76833 15 8.93753 15H14.5625C15.7317 15 16.7331 15.6336 17.4164 16.5448C17.6597 16.8691 17.8671 17.2331 18.0333 17.627C21.0539 14.3923 20.9871 9.32023 17.8336 6.16637ZM7.28363 17.4448C7.08244 17.7131 6.91002 18.0314 6.77855 18.3882C9.67745 20.7634 13.8159 20.866 16.8218 18.6958C16.6841 18.213 16.4738 17.7879 16.2164 17.4448C15.7462 16.8178 15.1537 16.5 14.5625 16.5H8.93753C8.34632 16.5 7.7539 16.8178 7.28363 17.4448Z"
    }, null, -1)
  ])))
}
export default { render: render }